// 引入JSON
import qs from 'qs';
import axios from "axios";
import config from "../../config";
export function setUserInfo (userInfo) {
    userInfo.lastActionTime = new Date().getTime();
    localStorage.userInfo = qs.stringify(userInfo);
}

export function getUserInfo () {
    return qs.parse(localStorage.userInfo);
}

export function removeUserInfo () {
    localStorage.removeItem('userInfo');
}

/**
 * 检查用户是否已经登录，如果已经登录，是否已经超过30分钟未操作，如果超过则检查后端是否登录过期，如果过期则清除用户信息，如果没过期则返回true
 * @returns {boolean}
 */
export async function checkUserInfo() {
    try {
        const userInfo = getUserInfo();
        if (userInfo) {
            let res = new Date().getTime()  > userInfo.lastActionTime + 30 * 60 * 1000;
            if (res) {
                removeUserInfo();
                //检查下后端是否登录过期
                let data = await getLoginInfo();
                if (data){
                    userInfo.lastActionTime = new Date().getTime();
                    setUserInfo(userInfo);
                }
            }
            return true;
        }
        removeUserInfo();
        return false;
    } catch (e) {
        removeUserInfo();
        console.log(e);
        return false;
    }
}

async function getLoginInfo(){
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: config.serverUrl + 'getUser.json',
            data: {},
        }).then(res => {
            resolve(res.data.data);
        }).catch(err => {
            reject(err);
        })
    })
}
